import React, { useEffect } from 'react';
import DataAnalysisTable from '../Components/DataAnalysisTable';
import './DataAnalysis.css';

const DataAnalysis = () => {
  useEffect(() => {
    document.title = 'Data Analysis - MotionAir';
  }, []);

  return (
    <div className="data-analysis-container">
      <div className="data-analysis-header">
        <h1>ID Duplicate Checker</h1>
        <p>Simple and perfect duplicate detection: Fetch 10 recent events, then find ALL events with the same ID in the database. Keep the earliest (FIRST created), delete the rest.</p>
      </div>
      <DataAnalysisTable />
    </div>
  );
};

export default DataAnalysis;
